import { ColorManager } from "../../lib/layers/selectable/color";
import { GroupLayer, MarkerLayer, MeasureLayer, ZoomboxLayer } from "../layers/client/ClientLayers";
import { SketchLayer } from "../layers/client/SketchLayer";
import { InspectionsLayer } from "../layers/selectable/InspectionsLayer";
import { ParcelLayer } from "../layers/selectable/ParcelLayer";
import { KellyStrategy, LinearStrategy, RadialStrategy, SingleColorStrategy } from "../layers/selectable/strategies";
import { ColorizedParcelStyle, DefaultParcelStyle } from "../layers/selectable/styles";
const init_select = (view, config) => {
    const color_manager = new ColorManager({
        strategies: [new KellyStrategy(), new SingleColorStrategy(), new LinearStrategy(), new RadialStrategy()],
        color_range: {
            start_color: '#FF0000',
            end_color: '#0000FF',
            num_colors: 5,
            opacity: 100
        }
    });
    const layer_options = {
        url: config.ParcelQueryUrl,
        identifier: config.ParcelIdentifierColumn,
        color_manager: color_manager
    };
    const styles = [new DefaultParcelStyle(), new ColorizedParcelStyle()];
    let layer;
    if (view === 'inspections')
        layer = new InspectionsLayer(layer_options);
    else
        layer = new ParcelLayer(layer_options);
    layer.style_manager.add_styles(...styles);
    return layer;
};
const gsaLayers = {
    parcel: init_select,
    marker: (parcel_layer) => new MarkerLayer(parcel_layer),
    sketch: new SketchLayer(),
    group: GroupLayer,
    measure: MeasureLayer,
    zoombox: ZoomboxLayer
};
export { gsaLayers as GSALayers };
